import { Environment } from './environment.type';

export namespace AppInfo {
  export let Environment!: Environment;
  export function _setEnvironmentValue(environmentDetails: Environment) {
    Environment = environmentDetails;
  }
}
